'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MONTHS_LIST = exports.MONTHS_LIST = {
  full: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  compact: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
};